import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import BoxRenderer from "../../../box-renderer/BoxRenderer";
const useStyles = makeStyles({
  icon: {
    position: "absolute",
    left: 8
  },
  titleContainer: {
    marginBottom: ({
      gutterBottom
    }) => gutterBottom ? 16 : 0
  }
});
const OnboardingAnswerTypeSummary = ({
  reviewSummary,
  gutterBottom = false,
  showTitle = true,
  message = {}
}) => {
  const classes = useStyles({
    gutterBottom
  });
  const {
    t
  } = useTranslation();
  const {
    title,
    subtitle,
    hasError,
    hasCorrectReply
  } = reviewSummary;
  const subtitleBoxProps = hasError ? {
    boxColor: "error-cold"
  } : hasCorrectReply ? {
    boxColor: "secondary-main"
  } : {
    boxColor: "",
    iconElement: ""
  };
  const BoldText = ({
    title,
    score
  }) => {
    return /*#__PURE__*/React.createElement("span", null, message.qualityReviewGroup ? /*#__PURE__*/React.createElement(React.Fragment, null, t(`${title} `), /*#__PURE__*/React.createElement("span", {
      style: {
        fontWeight: "bold"
      }
    }, score)) : /*#__PURE__*/React.createElement(React.Fragment, null, t(title), " and scored ", /*#__PURE__*/React.createElement("span", {
      style: {
        fontWeight: "bold"
      }
    }, score)));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showTitle && title !== "" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes.titleContainer
  }, /*#__PURE__*/React.createElement(BoxRenderer, {
    showRadius: true,
    color: "default",
    value: hasCorrectReply && message.reviewScore ? /*#__PURE__*/React.createElement(BoldText, {
      title: title,
      score: message.reviewScore
    }) : t(title),
    variant: "contained",
    containerStyles: {
      padding: "4px 12px"
    },
    noMargin: true,
    id: "answerSummaryTitle"
  })), subtitle !== "" && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(BoxRenderer, {
    showRadius: true,
    variant: "caption",
    value: hasCorrectReply && message.reviewScore ? /*#__PURE__*/React.createElement(BoldText, {
      title: subtitle,
      score: message.reviewScore
    }) : t(subtitle),
    containerStyles: {
      padding: "4px 12px"
    },
    color: subtitleBoxProps.boxColor,
    noMargin: true,
    id: "answerSummarySubTitle"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.icon
  }, subtitleBoxProps.iconElement))));
};
OnboardingAnswerTypeSummary.propTypes = {
  reviewSummary: PropTypes.object.isRequired,
  message: PropTypes.object,
  showTitle: PropTypes.bool,
  gutterBottom: PropTypes.bool,
  score: PropTypes.string,
  title: PropTypes.string
};
export default OnboardingAnswerTypeSummary;